<template>
  <div>
  <div class="file-item flex-column flex-md-row" :class="{'bg-selected': isSelected(output) === true}"
       v-for="output in currentJob.apiJob?.output" v-if="complete" @click="toggleSelection(output)">
    <div class="item d-inline-flex gap-10px">
      <input type="checkbox" :checked="isSelected(output)">
      <div class="item hoverFileListItem" @mousemove="mouseOver(output)" @mouseenter="mouseEnter(output)"
           @mouseleave="mouseOut(output)">
        <div class="thumb-small no-preview"
             v-if="canPreviewMini(output) === false || currentJob.thumbnails.small_enabled === false">
          <i class="far fa-file"></i>
        </div>
        <div class="thumb-small" @click="openPreview(output)"
             v-if="canPreviewMini(output) && currentJob.thumbnails.small_enabled === true"
             :class="{'filename-cursor': canPreview(output) === true}">
          <div v-if="isSmallThumbnailByOutputLoading(output)">
            <div class="placeholder">
              <div class="animated-background"></div>
            </div>
          </div>
          <img id="previewed-image" class="" v-if="!isSmallThumbnailByOutputLoading(output)"
               :src="getThumbnailForOutput(output)">
        </div>
      </div>
      <a
          class="filename-cursor short-text-name"
          data-toggle="tooltip"
          data-trigger="hover"
          v-bind:title="'Right-Click, Save As'| trans"
          @click.stop="download(output)"
          :href="output.download_uri"
      >{{ output.uri|getFilenameFromUrl | decodeUrl }}</a>
      <span class="text-muted "
            :class="{'line-through': isCompressJob()  === true, 'd-none': (isCompressJob() === true && !isOutputSmaller(output)) || isCompressJob() === false }">
            {{ getReadableSize(getInputForOutput(output).size) }}
          </span>
      <span class="text-muted">
            {{ getReadableSize(output.size) }}
          </span>
      <div class="position-relative">
        <div class="thumb-preview" v-if="hoverOutput.id === output.id">
          <div class="placeholder" v-if="isSmallThumbnailByOutputLoading(hoverOutput)">
            <div class="animated-background"></div>
          </div>
          <img @load="imageChanged" id="previewed-image" class="w-100 h-auto"
               v-if="!isSmallThumbnailByOutputLoading(hoverOutput)" :src="getThumbnailForOutput(hoverOutput)">
        </div>
      </div>
    </div>

    <div class="item">
      <i v-if="output.status === 'uploading'" class="fa fa-spin btn-loading-animation lh-inherit spinner-basic"></i>
      <i v-if="output.status === 'uploading-init'" class="far fa-cloud-upload"></i>
    </div>
    <div class="flex-grow-1 justify-content-end d-flex file-actions item align-items-center">
      <div v-if="isCompressJob() === true">
        <div class="compress-success m-0" v-if="isOutputSmaller(output)">
          <strong>{{ 'Compressed by' | trans }}
            {{ getCompressDiff(output).diff_perc }}%
          </strong>
        </div>
        <div class="compress-failed m-0" v-if="isOutputSmaller(output) === false">
          <strong>{{ 'Can\'t compress any further' | trans }}
          </strong>
        </div>
      </div>
      <div>
        <div class="file-action-btn"
             data-toggle="tooltip"
             data-trigger="hover"
             v-if="true === false"
             v-bind:title="'File Info'| trans"
        ><i class="far fa-info-circle"></i></div>
      </div>
      <div v-if="canPreview(output)">
        <div class="file-action-btn"
             @click.stop="openPreview(output)"
             data-toggle="tooltip"
             data-trigger="hover"
             v-bind:title="'Preview'| trans"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="currentColor"
                  d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5"/>
          </svg>
        </div>
      </div>
      <div v-if="true === false">
        <div class="upload-btn"
             data-toggle="tooltip"
             data-trigger="hover"

             v-bind:title="'Upload To Cloud'| trans"
        ><i class="far fa-cloud-upload"></i></div>
      </div>
      <div>
        <a class="download-btn gap-10px"
           :href="output.download_uri"
           v-bind:title="'Download'| trans"
           @click.stop="download(output)"
        ><i class="far fa-download lh-inherit"></i> Download</a>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'
import currentJob from './../../../mixins/current_job.mixin'
import PreviewManager from "../../../manager/PreviewManager";
import JobManager from "../../../manager/JobManager";
import OutputSelectionManager from "../../../manager/OutputSelectionManager";
import DownloadManager from "../../../manager/DownloadManager";
import ThumbnailManager from "../../../manager/ThumbnailManager";
import Error from "../../Elements/Error.vue";
import {formatting} from "../../../../../../../helper/formatting";
import Analytics from "../../../util/Analytics";
import FeedbackFull from "../../Elements/FeedbackFull.vue";

export default {
  name: "FileListOutputs",
  props: {},
  components: {FeedbackFull, Error},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      hoverOutput: {id: null}
    };
  },
  mounted: function () {

  },
  created: function () {
  },
  filters: {
    getFilenameFromUrl(url) {
      let lastSlashIndex = url.lastIndexOf('/')
      return url.substring(lastSlashIndex + 1)
    },
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }

  },
  methods: {
    imageChanged() {
    },
    mouseEnter(output) {
      if (PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output), output.size) === true) {
        this.hoverOutput = output;
        //ThumbnailManager.generateThumbnail(this.currentJob, [output]);
      } else {
        this.hoverOutput = {id: null}
      }
    },
    mouseOut(e) {
      this.hoverOutput = {id: null}
    },
    mouseOver(e) {
      this.mouseEnter(e);
      //let cursor = document.getElementById("preview-img");
      //cursor.style.display = 'inherit';
    },
    getReadableSize(size) {
      return formatting.fileSize(size);
    },
    isOutputSmaller(output) {
      return JobManager.isOutputSmaller(output, this.currentJob);
    },
    getCompressDiff(output) {
      return JobManager.getOutputCompressDiff(output, this.currentJob);
    },
    isCompressJob() {
      return JobManager.isCompressJob(this.currentJob);
    },
    getInputForOutput(output) {
      let input = JobManager.getInputByOutputSource(output, this.currentJob);
      return input[0];
    },
    getThumbnailForOutput(output) {
      return ThumbnailManager.getSmallThumbnailByOutput(this.currentJob, output);
    },
    isSmallThumbnailByOutputLoading(output) {
      return ThumbnailManager.isSmallThumbnailByOutputLoading(this.currentJob, output);
    },
    generateThumbnail(output) {
      ThumbnailManager.generateThumbnail(this.currentJob, output);
    },
    download(output) {
      DownloadManager.downloadOutput(output);
    },
    selectAll() {
      Analytics.send('result_action', 'select_all', this.currentJob);

      OutputSelectionManager.selectAll(this.currentJob);
    },
    deselectAll() {
      Analytics.send('result_action', 'deselect_all', this.currentJob);

      OutputSelectionManager.deselectAll(this.currentJob);
    },
    isSelected(output) {
      return OutputSelectionManager.isOutputSelected(this.currentJob, output);
    },
    toggleSelection(output) {
      OutputSelectionManager.toggleOutput(this.currentJob, output)
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
    },
    openPreview(output) {
      if (this.canPreview(output) === false) {
        return;
      }

      $('[data-toggle="tooltip"]').tooltip('hide');
      PreviewManager.openPreview(this.currentJob, output);
    },
    canPreview(output) {
      return PreviewManager.canPreview(JobManager.getExtensionFromOutput(output));
    },
    canPreviewMini(output) {
      if (this.currentJob.thumbnails.small.length > 0) {
        if (this.isSmallThumbnailByOutputLoading(output) === true) {
          return false;
        }
      }

      return PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output), output.size);
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.short-text-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.gap-10px {
  gap: 10px;
}

.filename-cursor {
  pointer-events: inherit;
  cursor: pointer;
}

.bg-selected {
  background: #f8f8ff !important;
  border-bottom: 1px solid #D9E7FD !important;
}

.thumb-small {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  z-index: 10;
  overflow: hidden;

  &.no-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F5F5;
    color: #6C757D;
    cursor: inherit;
  }

  img {
    object-fit: cover;
    width: 50px;
    height: 50px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }
}

.thumb-preview {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 150px;
  height: auto;
  position: absolute;
  right: -170px;
  top: -55px;
  padding: 5px;
  z-index: 10;

  img {
    z-index: 100;
    border-radius: 0px;
  }

  .placeholder {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  .animated-background {
    height: 135px !important;
    border-radius: 9px;
    overflow: hidden;
  }

  &:before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 45px;
    left: -10px;
    height: 20px;
    width: 20px;
    background: white;
    transform: rotate(45deg);
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
}

.placeholder {
  margin: 0;
  width: 100%;
  max-width: 1400px;
  background-color: #eee;
  border-radius: 4px !important;
  overflow: hidden;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 1468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 2800px 104px;
  height: 100%;
  position: relative;
  top: 0;
}


#preview-img {
  transition: width 2s, height 4s;
  background: white;
  border: 1px solid #ccc;
  display: none;
  width: 100px;
  height: auto;
  z-index: 1000;
  padding: 5px;
  position: absolute;
  max-height: 300px;
  overflow: hidden;
}

.line-through {
  text-decoration: line-through;
}

.spinner-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;

  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}

.global-actions-container-top {
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    border-bottom: 1px solid #595959;
  }
}

.global-actions-container {
  padding: 10px;

  .dark-mode & {
    background: #272727;
    color: white;
  }
}

.feedback-full {
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  padding: 20px;
}

.file-container {
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  width: 100%;
  background: #FBFBFB;

  .dark-mode & {
    border: 1px solid #595959;
  }
}

.file-actions {
  gap: 10px;
}

.file-item {
  .item {
    display: flex;
    align-items: center;
  }

  vertical-align: center;
  padding: 10px;
  display: flex;
  gap: 5px;
  background: white;
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.download-btn {
  cursor: pointer;
  background: #1266F1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.upload-btn {
  cursor: pointer;

  i {
    line-height: inherit;
  }

  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.file-action-btn {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}

.compress-success {
  background: #CCF4DC;
  color: #0B7335;
  border: 1px solid #0B7335;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.compress-failed {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: #6C757D;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.placeholder {
  margin: 0 auto;
  max-width: 400px;
  min-height: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 4px;
  opacity: .6;
  background-color: #eee;
  transition: all 1s;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100px;
  position: relative;
}
</style>
